module.exports = __webpack_public_path__ + "img/orangepay.f01e0fa0.svg";